export const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);

export const emptyFieldRegex = RegExp(/^\s+$/);

/**
 * Validation rules applied:
 * 1. US/CA country code may precede the
 * 2. If country code present, must be "1" or "+1" (only supports US/CA)
 * 3. First area code digit may not be 0 or 1; second and third digits may be any number
 * 4. First digit of group following area code may not be 0 or 1; second and third digits may be any number
 * 5. Last four digits may be any numbers
 * 6. Dashes or spaces may be used to separate groups of digits, but are not required
 */
export const validPhoneRegex = RegExp(
  /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/i
);
